import script from "./KryptonDialog.vue?vue&type=script&lang=js"
export * from "./KryptonDialog.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__